import { Component, Input } from '@angular/core';
import { S1ButtonType } from '@app/s1';
import { IAssistenza } from '@app/shared/models/assistenza';

@Component({
  selector: 'ser-new-tab-button',
  templateUrl: './new-tab-button.component.html',
  styleUrl: './new-tab-button.component.scss'
})
export class NewTabButtonComponent {

  @Input() assistenza: IAssistenza;

  s1ButtonType = S1ButtonType;

}
